import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "reactstrap";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaBirthdayCake,
  FaChalkboardTeacher,
  FaBookOpen,
  FaGraduationCap,
  FaBuilding,
  FaUniversity,
  FaGlobeAmericas,
  FaMapMarkerAlt,
  FaLink,
} from "react-icons/fa";
import PageLayout from "../PageLayout";
import { useNavigate } from "react-router-dom";
import { getAuthorDetailsApi } from "src/network/api";
import { updateUserDetails } from "src/state/slices/authSlice";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "src/state/store/store";

const AuthorProfile = () => {
  const { auth } = useAppSelector((state) => state);
  const [authorDetails, setAuthorDetails] = useState(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const fetchAuthorDetails = async () => {
      try {
        const data = await getAuthorDetailsApi();
        setAuthorDetails(data.data);
        console.log(data.data);
        dispatch(updateUserDetails(data.data));
      } catch (error) {
        console.error("Error fetching author details:", error);
      }
    };

    fetchAuthorDetails();
  }, [auth.activeAccount]);

  const handleEditProfile = () => {
    navigate("/update-profile");
  };

  if (!authorDetails) {
    return (
      <PageLayout>
        <Container fluid>
          <Row className="justify-content-center">
            <Col md="8" className="text-center mb-5">
              <Card
                className="p-4 shadow mt-5"
                style={{ borderRadius: "10px" }}
              >
                <h4>Loading details...</h4>
              </Card>
            </Col>
          </Row>
        </Container>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="author-profile-page bg-light">
        <Container fluid>
          {/* Profile Header */}
          <Row className="justify-content-center">
            <Col md="8" className="text-center">
              <Card
                className="p-4 shadow mt-5"
                style={{ borderRadius: "10px" }}
              >
                <div className="profile-header">
                  <img
                    src={
                      authorDetails.profile_image ||
                      "https://via.placeholder.com/150"
                    }
                    alt="Author"
                    className="rounded-circle img-thumbnail mb-3"
                    style={{ width: "150px", height: "150px" }}
                  />
                  <Button
                    color="success"
                    size="sm"
                    style={{
                      borderRadius: "20px",
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                    }}
                    onClick={handleEditProfile}
                  >
                    Edit Profile
                  </Button>

                  <h3 className="text-primary">
                    {authorDetails.name || "N/A"}
                  </h3>
                  <p className="text-muted">
                    {authorDetails.designation || "N/A"}
                  </p>
                  <div className="mt-3">
                    {authorDetails.approval_status == "pending" ? (
                      <label className="badge badge-warning">
                        Verification Pending
                      </label>
                    ) : authorDetails.approval_status == "rejected" ? (
                      <label className="badge badge-danger">
                        Profile Rejected{" "}
                      </label>
                    ) : (
                      <label className="badge badge-success">Verified</label>
                    )}

                    {/* <Button color="primary" size="sm" className="mr-2">
                      Follow
                    </Button>
                    <Button color="secondary" size="sm">
                      Contact
                    </Button> */}
                  </div>
                </div>
              </Card>
            </Col>
          </Row>

          {/* Basic Information */}
          <Row className="mt-4 justify-content-center">
            <Col md="8">
              <Card className="p-4 shadow" style={{ borderRadius: "10px" }}>
                <h5 className="text-primary" style={{ fontWeight: "bold" }}>
                  Basic Information
                </h5>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  <li>
                    <FaGraduationCap className="mr-2" />
                    <strong>Maximum Qualification:</strong>{" "}
                    <p className="ml-4">
                      {authorDetails.maximum_qualification || "N/A"}
                    </p>
                  </li>
                  <li>
                    <FaBuilding className="mr-2" />
                    <strong>Department/College:</strong>{" "}
                    <p className="ml-4">{authorDetails.department || "N/A"}</p>
                  </li>
                  <li>
                    <FaUniversity className="mr-2" />
                    <strong>University/Organisation:</strong>{" "}
                    <p className="ml-4">
                      {authorDetails.university_name || "N/A"}
                    </p>
                  </li>
                  <li>
                    <FaGlobeAmericas className="mr-2" />
                    <strong>Country:</strong>
                    <p className="ml-4">
                      {authorDetails.country_name || "N/A"}
                    </p>
                  </li>
                  <li>
                    <FaMapMarkerAlt className="mr-2" />
                    <strong>State:</strong>
                    <p className="ml-4">{authorDetails.state_name || "N/A"}</p>
                  </li>
                  <li>
                    <FaLink className="mr-2" />
                    <strong>Profile Link:</strong>{" "}
                    <p className="ml-4">
                      {" "}
                      {authorDetails.profile_link ? (
                        <a
                          href={authorDetails.profile_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Visit Profile
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </p>
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>

          {/* Contact Details */}
          <Row className="mt-4 justify-content-center">
            <Col md="8">
              <Card className="p-4 shadow" style={{ borderRadius: "10px" }}>
                <h5 className="text-primary" style={{ fontWeight: "bold" }}>
                  Contact Details
                </h5>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  <li>
                    <FaEnvelope className="mr-2" />
                    <strong>Email:</strong>
                    <p className="ml-4"> {authorDetails.email || "N/A"}</p>
                  </li>
                  <li>
                    <FaPhoneAlt className="mr-2" />
                    <strong>Phone:</strong>{" "}
                    <p className="ml-4"> {authorDetails.contact || "N/A"}</p>
                  </li>
                  <li>
                    <FaBirthdayCake className="mr-2" />
                    <strong>Date of Birth:</strong>{" "}
                    <p className="ml-4">
                      {authorDetails.dob !== "0000-00-00"
                        ? authorDetails.dob
                        : "N/A"}
                    </p>
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>

          {/* Professional Details */}
          <Row className="mt-4 justify-content-center">
            <Col md="8" className="mb-5">
              <Card className="p-4 shadow" style={{ borderRadius: "10px" }}>
                <h5 className="text-primary" style={{ fontWeight: "bold" }}>
                  Professional Details
                </h5>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  <li>
                    <FaChalkboardTeacher className="mr-2" />
                    <strong>Research Area:</strong>{" "}
                    <p className="ml-4">
                      {authorDetails.research_area || "N/A"}{" "}
                    </p>
                  </li>
                  <li>
                    <FaBookOpen className="mr-2" />
                    <strong>About:</strong>{" "}
                    <p className="ml-4"> {authorDetails.about || "N/A"}</p>
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </PageLayout>
  );
};

export default AuthorProfile;
